import { exclude, parse, stringifyUrl } from "query-string";

import { LeasingVehicleTypeEnum } from "../../../__generated__/fed-graphql-types";
import { LeaseOffersQuery_search_Search_advert_Advert_leasingOffers_LeaseTerms } from "../../../connected-components/hoc/query/__generated__/pdp-lease-offers.query";

export const buildUrlWithParams = (queryString: string, url: string) => {
  const parsedQuery = parse(queryString, { sort: false });
  return stringifyUrl(
    {
      url: url,
      query: {
        ...parsedQuery,
      },
    },
    {
      sort: false,
      skipNull: true,
      skipEmptyString: true,
    },
  );
};

export const returnSearchWithoutSpecifiedQueryParams = (
  search: string,
  excludedParams: Array<string>,
) => {
  return exclude(search, excludedParams);
};

export const buildBackToSearchResultsUrl = (url: string, search: string) => {
  const QUERY_PARAMS_TO_REMOVE = ["colour", "trim"];
  const backToSearchResultsSearch = returnSearchWithoutSpecifiedQueryParams(
    search,
    QUERY_PARAMS_TO_REMOVE,
  );

  const backToSearchResultsUrl = buildUrlWithParams(
    backToSearchResultsSearch,
    url,
  );
  return backToSearchResultsUrl ?? "";
};

export const buildNewQueryString = (
  search: string,
  advertId: string | undefined,
  contractType: string,
  selectedLeaseOffer:
    | LeaseOffersQuery_search_Search_advert_Advert_leasingOffers_LeaseTerms
    | undefined,
  selectedLeaseOption: string | undefined,
  pageLocation?: string,
) => {
  const specifiedQueryParams = [
    "leaseContractType",
    "trim",
    "colour",
    "advertId",
    "leaseOption",
    "lease_option",
  ];
  search = returnSearchWithoutSpecifiedQueryParams(
    search,
    specifiedQueryParams,
  );
  let additionalParams = "";
  advertId = advertId ?? "";
  additionalParams += contractType
    ? "&leaseContractType=" + encodeURIComponent(contractType)
    : "";
  additionalParams += selectedLeaseOffer?.upholstery
    ? "&trim=" + encodeURIComponent(selectedLeaseOffer.upholstery)
    : "";
  additionalParams += selectedLeaseOffer?.colour
    ? "&colour=" + encodeURIComponent(selectedLeaseOffer.colour)
    : "";
  additionalParams += selectedLeaseOption
    ? "&leaseOption=" + encodeURIComponent(selectedLeaseOption)
    : "";
  additionalParams += pageLocation
    ? "&fromLocation=" + encodeURIComponent(pageLocation)
    : "";

  if (!search) {
    return "?advertId=" + advertId + additionalParams;
  }
  return "?advertId=" + advertId + "&" + search.slice(1) + additionalParams;
};

export const buildEnquiryQueryString = (
  contractType: string,
  vehicleType: LeasingVehicleTypeEnum,
  selectedLeaseOffer:
    | LeaseOffersQuery_search_Search_advert_Advert_leasingOffers_LeaseTerms
    | undefined,
  advertId = "",
) => {
  let enquiryParams = "";
  const productAdvertId = advertId ?? "";

  enquiryParams += contractType
    ? "&leaseContractType=" + encodeURIComponent(contractType)
    : "";
  enquiryParams += vehicleType
    ? "&vehicleType=" + encodeURIComponent(vehicleType)
    : "";

  type LeaseOfferKeys =
    keyof LeaseOffersQuery_search_Search_advert_Advert_leasingOffers_LeaseTerms;

  const leaseKeys =
    selectedLeaseOffer && (Object.keys(selectedLeaseOffer) as LeaseOfferKeys[]);
  const filteredLeaseKeys = leaseKeys?.filter(
    (key) => key !== "__typename" && key !== "deliveryEstimateDays",
  );

  if (filteredLeaseKeys && selectedLeaseOffer) {
    for (const key of filteredLeaseKeys) {
      if (selectedLeaseOffer[key] !== "" && selectedLeaseOffer[key] !== 0) {
        enquiryParams += `&${key}=${encodeURIComponent(
          selectedLeaseOffer[key] || "",
        )}`;
      }
    }
  }

  if (enquiryParams.charAt(0) === "&") {
    enquiryParams = enquiryParams.slice(1);
  }

  return "?advertId=" + productAdvertId + "&" + enquiryParams;
};
